import { Drawer, List, ListItem, IconButton, Typography, Box } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { UseCaseDefinition } from '../../../model';
import { getDocumentColor, getDocumentIcon } from '../../common/helpers';
import TileMenuItem from '../../tileMenu/Tile/TileMenuItem';

const useStyles = makeStyles(({ palette, spacing }) => ({
  drawer: {
    '& .MuiDrawer-paper': {
      width: 280,
      padding: spacing(2),
    },
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: spacing(1),
    borderBottom: `1px solid ${palette.divider}`,
    paddingBottom: spacing(1),
  },
  title: {
    fontWeight: 600,
  },
  listItem: {
    padding: spacing(0.5, 0),
    '& .MuiListItem-root': {
      padding: 0,
    },
  },
  tileMenuItem: {
    width: '100%',
    height: 60,
  },
}));

type Props = {
  open: boolean;
  onClose: () => void;
  definitions: UseCaseDefinition[];
  onGenerateTransactionClick: (useCaseDefinition: UseCaseDefinition) => void;
};

const ListFooterSidebar: React.FC<Props> = ({ open, onClose, definitions, onGenerateTransactionClick }) => {
  const classes = useStyles({});

  const handleItemClick = (definition: UseCaseDefinition) => {
    onGenerateTransactionClick(definition);
    onClose();
  };

  return (
    <Drawer anchor="right" open={open} onClose={onClose} className={classes.drawer}>
      <Box className={classes.header}>
        <Typography variant="h6" className={classes.title}>
          More Actions
        </Typography>
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </Box>
      <List dense disablePadding>
        {definitions.map((definition) => (
          <ListItem key={definition.processId} className={classes.listItem}>
            <TileMenuItem
              className={classes.tileMenuItem}
              tile={{
                label: definition.name,
                icon: getDocumentIcon(definition),
                color: getDocumentColor(definition),
                fullWidth: true,
              }}
              onClick={() => handleItemClick(definition)}
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default ListFooterSidebar;
